import { render, staticRenderFns } from "./QuotationDetailShop.vue?vue&type=template&id=96d458be&scoped=true&"
import script from "./QuotationDetailShop.vue?vue&type=script&lang=js&"
export * from "./QuotationDetailShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d458be",
  null
  
)

export default component.exports